import { Radio, RadioGroup } from '@velocity/ui';
import React from 'react';
import FormFieldShell, { FormFieldShellProps } from './form-field-shell';

export interface FormRadioOption {
  value: string;
  label: React.ReactNode;
  disabled?: boolean;
}

export interface FormRadioFieldProps extends FormFieldShellProps {
  options: ReadonlyArray<FormRadioOption>;
  value?: string | null;
  onChange: (value: string) => void;
  onBlur?: () => void;
  /** Render options horizontally (default) or stacked */
  row?: boolean;
  dataTestId?: string;
}

/*
 * Velocity `FormField` + `RadioGroup`, controlled so it can be used with
 * react-hook-form's `Controller`.
 */
const FormRadioField: React.FC<FormRadioFieldProps> = ({
  name,
  label,
  options,
  value,
  onChange,
  onBlur,
  row = true,
  hideLabel,
  errorMessage,
  hint,
  tooltip,
  required,
  disabled,
  dataTestId,
  className,
}) => (
  <FormFieldShell
    {...{
      name,
      label,
      hideLabel,
      errorMessage,
      hint,
      tooltip,
      required,
      disabled,
      className,
    }}
  >
    <RadioGroup
      name={name}
      row={row}
      value={value ?? ''}
      onChange={(event) => onChange(event.target.value)}
      onBlur={onBlur}
      data-testid={dataTestId ?? `radio-field-${name}`}
    >
      {options.map((option) => (
        <Radio
          key={option.value}
          value={option.value}
          label={option.label}
          disabled={option.disabled}
          data-testid={`radio-${name}-${option.value}`}
        />
      ))}
    </RadioGroup>
  </FormFieldShell>
);

export default FormRadioField;
